import fp from 'lodash/fp';
import { connect } from 'react-redux';
import {
  updateInventoryItem,
  fetchInventoryItem
} from '../../../../redux/Inventory/sagas/item/routines';
import { fetchInventoryTags } from '../../../../redux/Inventory/sagas/tag/routines';
import { getAllValues as getTags } from '../../../../redux/Inventory/selectors/tag';
import {
  getIsFetching,
  getIsSaving,
  getIsSaved,
  getItemForId
} from '../../../../redux/Inventory/selectors/item';
import { ItemType } from '../../../../constants/inventory/InventoryTypes';
import EditItem from '../component';

function mapStateToProps(state, { match: { params } }) {
  return {
    type: ItemType,
    tags: getTags(state),
    item: getItemForId(state, params.id),
    isFetchingItem: getIsFetching(state),
    isSaved: getIsSaved(state),
    isSaving: getIsSaving(state)
  };
}

function mapDispatchToProps(dispatch, { match: { params } }) {
  return {
    onInit: () => {
      dispatch(fetchInventoryTags());
      dispatch(fetchInventoryItem({ id: params.id }));
    },
    onSubmit: body => {
      const omitProps = [
        'id',
        'locationId',
        'createdAt',
        'updatedAt',
        'deletedAt'
      ];
      const payload = { id: body.id, body: fp.omit(omitProps, body) };
      dispatch(updateInventoryItem(payload));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditItem);
